export enum YesOrNoOrStopped {
    no = 'Nee',
    stopped = 'Gestopt',
    yes = 'Ja',
}

export enum YesOrNoOrStoppedOrUnknown {
    no = 'Nee',
    stopped = 'Gestopt',
    unknown = 'Onbekend',
    yes = 'Ja',
}
